import { Contract } from "ethers/lib/ethers";
import { useEffect, useState } from "react";
import { Json } from "styled-icons/simple-icons";

import { useWeb3React } from "@web3-react/core";

import BackupGoat from "../assets/gg-10.png";
import {
  useGnarlyGoatsContracts,
  useGnarlyGoatsContractsState,
  useSharedContractsState
} from "./useGnarlyGoatsContracts";

export interface Token {
	tokenId: string
	tokenUrl: string
}

export function useTokens() {
	const { account } = useWeb3React()

	const { contract, mintPassContract } = useGnarlyGoatsContracts()

	const {
		gnarlyGoatsClaimed,
		mintPassesClaimed,
		accountBalance,
		accountMintPassBalance,
	} = useGnarlyGoatsContractsState()

	const [mintPassTokens, setMintPassTokens] = useState<Token[]>()
	const [gnarlyGoatTokens, setGnarlyGoatTokens] = useState<Token[]>()

	useEffect(() => {
		getAccountTokens()
	}, [])

	async function getAccountTokens() {
		// console.log('Retrieving Account Token Metadata...')
		// console.log('Account Balance', accountBalance)
		// console.log('Account Mint Pass Balance', accountMintPassBalance)
		// console.log('Gnarly Goats Claimed', gnarlyGoatsClaimed)
		// console.log('Mint Passes Claimed', mintPassesClaimed)

		try {
			if (contract !== null && gnarlyGoatsClaimed > 0 && accountBalance > 0) {
				let accountTokens = await fetchAccountTokens(contract, 5366)
				setGnarlyGoatTokens(accountTokens)
			}

			if (
				mintPassContract != null &&
				mintPassesClaimed > 0 &&
				accountMintPassBalance > 0
			) {
				let accountTokens = await fetchAccountTokens(mintPassContract, 500)
				setMintPassTokens(accountTokens)
			}
		} catch (err) {
			console.log('error fetching account tokens')
		}
	}

	async function fetchAccountTokens(
		contract: Contract,
		maxSupply: number
	): Promise<any> {
		let accountTokenIds: number[] = []

		for (let i = 0; i < maxSupply; i++) {
			try {
				var ownerOfTokenAtIndex = await contract.ownerOf(i)
				if (ownerOfTokenAtIndex === account) {
					accountTokenIds.push(i)
				}
			} catch (err) {
				// fail silently
			}
		}

		var getAccountTokenURIs: Promise<[string, number][]> = Promise.all(
			accountTokenIds.map(async (id) => {
				let uri: string = await contract.tokenURI(id)
				return [uri, id]
			})
		)

		var accountTokenURIs = await getAccountTokenURIs

		console.log(accountTokenURIs)

		var getAccountTokenMetadata: Promise<Token[]> = Promise.all(
			accountTokenURIs.map(async ([uri, id]) => {
				const res = await fetch(uri)

				let _token: Token = {
					tokenUrl: `https://ipfs.gnarlygoats.com/ipfs/${id}`,
					tokenId: String(id),
				}

				if (res.ok) {
					const metadata = await res.json()
					_token.tokenUrl = metadata.image
				}

				return _token
			})
		)

		return await getAccountTokenMetadata
	}

	return {
		mintPassTokens,
		tokens: gnarlyGoatTokens,
	}
}
